import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const util = require('../utils/index');
const process = require('../env');

const getCredentials = () => {
  const userLogged = util.getUser();

  const credentials = {
    username: userLogged.login,
    password: userLogged.senha
  }

  return credentials;
}


export const registrarCheckinApi = async (formValue) => {
  try{
  
      const response = await axios.post(`${process.env.URL}/checkin/createCheckin`, formValue, {
        auth: getCredentials()
      })
  
      if (response.status === 200){
        return response.data;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}


export const listarCheckinsApi = async (body) => {
  try{
      const response = await axios.post(`${process.env.URL}/checkin/getCheckins`, body, {
        auth: getCredentials()
      })
      const users = response.data
      if (response.status === 200){
        return users;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const ultimoCheckin = async (body) => {
  try{
      const response = await axios.post(`${process.env.URL}/checkin/lastcheckin`, body, {
        auth: getCredentials()
      })
      const users = response.data
      if (response.status === 200){
        return users;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}


export const atualizarCheckinApi = async (formValue) => {
  try{
      const response = await axios.post(`${process.env.URL}/checkin/updateCheckin`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}
